
export const reportFacebookPixelLead = (conversionId: string) => {
    if (typeof window.fbq !== 'undefined') {
        window.fbq('track', 'Lead', {
            content_id: conversionId,
            content_type: 'trial'
        });
    }
};


export const initFacebookPixel = (pixelId: string, email?: string | null) => {
    if (typeof window.fbq !== 'undefined') {
        const options = email ? { em: email } : {};
        window.fbq('init', pixelId, options);
        window.fbq('track', 'PageView');
    }
}
